import VueRouter, { RawLocation, Route } from 'vue-router';

/**
 * VueRouter.push()。NavigationDuplicatedエラーは無視する。
 * @param router
 * @param location
 * @returns
 */
export function routerPush(router: VueRouter, location: RawLocation): Promise<void | Route> {
  return router.push(location)
    .catch(err => {
      // console.log("err="+JSON.stringify(err, null, 2));
      // エラー無視
      if (err.name === 'NavigationDuplicated') {
        return;
      }
      // 上記以外のエラーはスロー。
      throw err;
    });
}
